import { atom } from 'jotai';

export type FilterAccordionState = {
  [filter in FilterAccordionName]: boolean;
};

export enum FilterAccordionName {
  Location = 'Location',
  MakeModel = 'MakeModel',
  ModelYearRange = 'ModelYearRange',
  PriceRange = 'PriceRange',
  MileageRange = 'MileageRange',
  BodyStyles = 'BodyStyles',
  Engine = 'Engine',
  Transmission = 'Transmission',
  Drivetrain = 'Drivetrain',
  FeaturesTechnology = 'FeaturesTechnology',
  Condition = 'Condition',
  Colors = 'Colors',
  Category = 'Category',
  TruckOptions = 'TruckOptions',
  Advanced = 'Advanced',
}

const baseFilterAccordionAtom = atom<FilterAccordionState>({
  [FilterAccordionName.MakeModel]: true,
  [FilterAccordionName.ModelYearRange]: true,
  [FilterAccordionName.PriceRange]: true,
  [FilterAccordionName.MileageRange]: true,
  [FilterAccordionName.BodyStyles]: false,
  [FilterAccordionName.Engine]: false,
  [FilterAccordionName.Transmission]: false,
  [FilterAccordionName.Drivetrain]: false,
  [FilterAccordionName.FeaturesTechnology]: false,
  [FilterAccordionName.Condition]: false,
  [FilterAccordionName.Colors]: false,
  [FilterAccordionName.Category]: false,
  [FilterAccordionName.TruckOptions]: false,
  [FilterAccordionName.Advanced]: false,
  [FilterAccordionName.Location]: false,
});

const FilterAccordionAtom = atom(
  (get) => get(baseFilterAccordionAtom),
  (get, set, update: Partial<FilterAccordionState>) => {
    set(baseFilterAccordionAtom, { ...get(baseFilterAccordionAtom), ...update });
  }
);

export default FilterAccordionAtom;
